import { joiResolver } from "@hookform/resolvers/joi";
import { validationOptions } from "@sr-partner-portal/common";
import { type SubmitHandler, useForm } from "react-hook-form";
import { Content } from "../components/content";
import { MainLayout } from "../components/mainlayout";
import { NavigationButtons } from "../components/navigation-button";
import { useResumeBuilder } from "../context";
import { useNavigateWithParams } from "../hooks";
import type { Resume } from "../types";
import { resumeValidationSchema } from "../validation";
import { ResumeStep1Form } from "./resume-step-1-form";

const ResumeBuilder1Page = () => {
    const { resumeContent, updateStep1 } = useResumeBuilder();
    const navigate = useNavigateWithParams();

    const formController = useForm<Resume>({
        resolver: joiResolver(resumeValidationSchema, validationOptions),
        defaultValues: {
            name: resumeContent.step1?.name || "",
            email: resumeContent.step1?.email || "",
            phone: resumeContent.step1?.phone || "",
            street: resumeContent.step1?.street || "",
            postalCode: resumeContent.step1?.postalCode || "",
            city: resumeContent.step1?.city || "",
            status: resumeContent.step1?.status || "",
            numberOfChildren: resumeContent.step1?.numberOfChildren,
            birthDate: resumeContent.step1?.birthDate || null,
        },
    });

    const handleSubmit: SubmitHandler<Resume> = (data) => {
        updateStep1(data);
        navigate("/step2");
    };

    const handlePreview = () => {
        const data = formController.getValues();
        const validatedData = resumeValidationSchema.validate(
            data,
            validationOptions,
        )?.value;

        if (!validatedData) {
            return;
        }

        updateStep1(validatedData);
    };

    const submitForm = formController.handleSubmit(handleSubmit);

    return (
        <MainLayout>
            <Content title="Allgemeine Daten" currentStep={1}>
                <ResumeStep1Form
                    formController={formController}
                    onSubmit={handleSubmit}
                    onPreview={handlePreview}
                />
                <NavigationButtons
                    onBack={() => navigate(-1)}
                    onNext={submitForm}
                    onPreview={handlePreview}
                />
            </Content>
        </MainLayout>
    );
};

export { ResumeBuilder1Page };
